/**
 * API Configuration for Taza Tropics Application
 * 
 * IMPORTANT: Payment Gateway Modes (Live/Test)
 * ============================================
 * All payment gateway configurations (PayPal, Stripe, Razorpay, etc.) 
 * are controlled by the BACKEND, not this frontend configuration.
 * 
 * The backend API returns the appropriate credentials based on admin settings:
 * - Sandbox/Test credentials for testing
 * - Live credentials for production
 * 
 * This ensures:
 * 1. No sensitive credentials in frontend code
 * 2. Environment switching without rebuilding frontend
 * 3. Centralized payment configuration management
 */

export const API_CONFIG = {
  // Always use direct URLs
  BASE_URL: 'https://api.tazatropics.com/public/api/',
  IMAGE_URL: 'https://api.tazatropics.com/public/storage/images/',
};

export const API_ENDPOINTS = {
  // Categories
  CATEGORIES: {
    GET_HOME: 'v1/category/getHome',
    GET_ALL: 'v1/categories/getAll',
  },
  // Products
  PRODUCTS: {
    SEARCH_QUERY: 'v1/products/searchQuery',
    GET_BY_ID: 'v1/products/getById',
    GET_BY_STORE_ID: 'v1/products/getByStoreId',
    GET_BY_CATEGORY: 'v1/products/getByCategoryId',
    GET_BY_SUBCATEGORY: 'v1/products/getBySubCategoryId',
  },
  // Home
  HOME: {
    SEARCH_WITH_CITY: 'v1/home/searchWithCity',
    SEARCH_WITH_GEO: 'v1/home/searchWithGeoLocation', // Use geolocation search endpoint
    SEARCH_WITH_ZIP: 'v1/home/searchWithZipCode',
  },
  // Cities
  CITIES: {
    GET_ALL: 'cities/getAll',
  },
  // Cart Management
  CART: {
    VALIDATE_COUPON: 'coupons/validate',
    SYNC: 'cart/sync',
  },
  // Orders
  ORDERS: {
    CREATE: 'orders/create',
    GET_BY_UID: 'orders/getByUid',
  },
  // Addresses
  ADDRESS: {
    GET_BY_UID: 'address/getByUid',
    ADD_NEW: 'address/addNew',
  },
  // Chat Support
  CHATS: {
    GET_CHAT_LIST: 'v1/chats/getChatListBUid',
    GET_CHAT_ROOMS: 'v1/chats/getChatRooms',
    CREATE_CHAT_ROOMS: 'v1/chats/createChatRooms',
    GET_BY_ROOM_ID: 'v1/chats/getById',
    SEND_MESSAGE: 'v1/chats/sendMessage',
  },
  // Utilities
  UTILITIES: {
    GET_SETTINGS: 'v1/utilities/getSettings',
  },
};

export default API_CONFIG;